var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { Box, Flex, Badge, IconButton, CloseButton, Tooltip, Image } from 'pcln-design-system';
import styled from 'styled-components';
import { InformationOutline } from 'pcln-icons';
var StyledFlex = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  button#openTooltipButton + div {\n    div {\n      width: 185px;\n      left: -7px;\n    }\n  }\n"], ["\n  button#openTooltipButton + div {\n    div {\n      width: 185px;\n      left: -7px;\n    }\n  }\n"])));
var TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_penny_logo.svg';
/**
 * DefaultModalHeader for chat modal
 * @public
 */
export var DefaultModalHeader = function (props) {
    var _a = useState(false), isDisplayed = _a[0], setTooltipDisplayState = _a[1];
    useEffect(function () {
        if (props.onDefaultModalHeaderRendered) {
            props.onDefaultModalHeaderRendered();
        }
    }, []);
    var closeButtonProps = {
        'data-testid': 'closeDialogModal',
        color: 'text.dark',
        onClick: function (e) {
            e.preventDefault();
            props.onClose();
        },
    };
    var IconButtonProps = {
        ml: 2,
        id: 'openTooltipButton',
        'data-testid': 'openTooltipButton',
        title: 'open tooltip',
        onClick: function (e) {
            e.preventDefault();
            setTooltipDisplayState(!isDisplayed);
        },
        icon: React.createElement(InformationOutline, { size: 16 }),
    };
    return (React.createElement(Box, { width: 1, style: { position: 'fixed', top: 0, zIndex: 10 } },
        React.createElement(StyledFlex, { p: 2, align: 'center' },
            React.createElement(Image, { src: TRAVEL_BOT_LOGO, mr: 2, height: '28', width: '68', alt: 'Travel Bot Logo' }),
            props.defaultHeaderBadge ? (props.defaultHeaderBadge) : (React.createElement(Badge, { color: 'primary', bg: 'background.light' }, "BETA")),
            React.createElement(Box, { mr: 'auto' },
                React.createElement(IconButton, __assign({}, IconButtonProps)),
                isDisplayed && (React.createElement(Tooltip, { bg: 'background.darkest', color: 'background.lightest', zIndex: 10, left: true }, "Powered by ChatGPT. Chat transcripts are recorded for quality review purposes. Bot may produce inaccurate information. Please do not share any personal information in the chat."))),
            React.createElement(CloseButton, __assign({}, closeButtonProps))),
        React.createElement(Box, { bg: 'background.tint', width: 1, height: '1px' })));
};
var templateObject_1;
//# sourceMappingURL=DefaultModalHeader.js.map